import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getStatementBySlug, Statement } from "../../firebase/statements";
import StatementDetail from "./Detail";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../firebase/AuthProvider";
//import Comments from "../comments/Comments";
import { Grid } from "@material-ui/core";
import Spinner from "../shared/Spinner";

type StatusType = "idle" | "loading" | "done" | "notfound";

export default function StatementPage() {
  const { t } = useTranslation();
  const { isAdmin } = useAuth();
  const [status, setStatus] = useState<StatusType>("idle");

  const [statement, setStatement] = useState<Statement | null>(null);
  const { pathname: slug } = useLocation();

  useEffect(() => {
    async function fetch() {
      if (!slug) return;
      setStatus("loading");
      const statement = await getStatementBySlug(slug, isAdmin);
      statement ? setStatus("done") : setStatus("notfound");
      setStatement(statement);
    }
    fetch();
  }, [slug, isAdmin]);

  if (status === "loading") return <Spinner isVisible={true} />;

  if (status === "notfound") return <div>{t("statement.notfound")}</div>;

  if (status === "done")
    return (
      <Grid item container xs={12}>
        {statement && (
          <>
            <StatementDetail statementId={statement.id} />
            {/*  <Comments statement={statement} /> */}
          </>
        )}
      </Grid>
    );

  return null;
}
